export const currentCardID: string = "current-card";
export const leftCardID: string = "left-card";
export const rightCardID: string = "right-card";
export const upCardID: string = "top-card";
export const downCardID: string = "bottom-card";

export const leftArrow: string = "left-arrow";
export const rightArrow: string = "right-arrow";
export const upArrow: string = "up-arrow";
export const downArrow: string = "down-arrow";

export const instructionOverlay: string = "#instruction";

export namespace Indicators {

  export const container: string = "#indicators";
  export const area: string = "#indicator-toucharea";
  export const left: string = "#leftindicator";
  export const right: string = "#rightindicator";
  export const up: string = "#upindicator";
  export const down: string = "#downindicator";

}

export namespace Stamps {

  export const left: string = "#leftstamp";
  export const right: string = "#rightstamp";
  export const up: string = "#upstamp";
  export const down: string = "#downstamp";

}